<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <v-col cols="12" >
      <h1>Категории</h1>
      <v-row>
        <v-col class="text-right">
          <v-btn @click="$router.push({ name: 'category-create'})">Создать</v-btn>
        </v-col>
      </v-row>
      <v-data-table
              no-data-text="Нет категорий"
              :headers="headers"
              :items="categories"
              :footer-props="footerProps"
              :header-props="{sortIcon: 'icon-custom-arrow'}"
              :loading="loading"
              :items-per-page="-1"
              :fixed-header="true"
              height="73vh"
              loading-text="Загрузка категорий... Подождите пожалуйста"
      >
        <template v-slot:item="{item,index}">
          <tr class="grouped-row">
            <td :class="{'pl-13': item.children.length === 0}">
              <template v-if="item.children.length > 0" >
                <v-icon class="mr-2" v-if="item.show" @click="item.show = false">mdi-chevron-up</v-icon>
                <v-icon class="mr-2" v-else @click="item.show = true">mdi-chevron-down</v-icon>
              </template>
              {{ item.name }}
            </td>
            <td>
              <div class="category-svg" v-html="item.svg"></div>
            </td>
            <td class="text-right">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                          small
                          class="mr-2"
                          v-bind="attrs"
                          v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item @click="$router.push({ name: 'category-edit', params: { id: item.id } })">
                    <v-list-item-title>Редактировать</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="submitDialog = true; submitItem = item">
                    <v-list-item-title>Удалить</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
          <template v-if="item.children.length > 0">
            <tr v-for="children in item.children" v-if="item.show" >
              <td class="pl-13">{{ children.name }}</td>
              <td class="text-left"><v-img v-if="children.main_image" :src="children.main_image.url" max-height="32px" position="left" contain></v-img></td>
              <td></td>
            </tr>
          </template>
        </template>
      </v-data-table>
    </v-col>
    <v-overlay
            :z-index="4"
            :value="overlay"
    >
    </v-overlay>
    <v-dialog
            v-model="submitDialog"
            max-width="444"
    >
      <v-card>
        <v-card-title >
          Подтвердить действие
        </v-card-title>

        <v-card-actions>


          <v-btn
                  v-if="submitItem == null"
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  v-else
                  @click="submitDelete(submitItem); submitDialog = false">
            Да
          </v-btn>
          <v-btn
                  outlined
                  @click="submitDialog = false"
          >
            Нет
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  // @ is an alias to /src

  import CategoryService from './../../api/CategoryService'

  export default {
    name: 'ModifierIndex',
    components: {},
    data: () => ({
      filters: {
        category: {
          value: [],
          tempValue: [],
          modal: false,
        },
      },
      overlay: false,
      loading: true,
      submitDialog: false,
      submitItem: null,
      categories: [],
      options: {},
      footerProps: {
        itemsPerPageText: 'Категорий на страницу',
        pageText: '{0}-{1} из {2}',
        itemsPerPageAllText: 'Все',
        itemsPerPageOptions: [-1]
      },
      headers: [
        {
            text: 'Категория',
            value: 'name',
          sortable: false
        },
        {
            text: 'Изображение',
            value: 'svg',
            sortable: false
        },
        {text: 'Действия', value: 'actions', sortable: false, width: "5%"},
      ],
    }),
    mounted() {
        this.getDataFromApi()
    },
    watch: {
      options: {
        handler() {
          this.getDataFromApi()
        },
        deep: true,
      }
    },
    methods: {
      submitDelete(item = null){
        if(item){
          this.removeCategory(item)
        } else {
          // this.massDelete()
        }
      },
      removeCategory(item){
          CategoryService.remove(item.id).then(response => {
            this.loading = true;
              this.getDataFromApi()
          });
      },
      getDataFromApi() {
        this.loading = true

        let params = {
        }
        CategoryService.listWithChildren(params)
          .then(response => {
            this.categories = response.data
            this.loading = false
          })
      },
    }
  }
</script>

<style lang="scss">
  .category-svg{
    svg{
      width: 37px;
      height: 37px;
      path{
        stroke: #000
      }
    }
  }
  .grouped-row{
    background: #FAFCFF;
  }

</style>
<style lang="scss" scoped>
  .v-btn--fab.v-size--x-small {
    width: 20px;
    height: 20px;

    .mdi::before {
      font-size: 12px;
    }
  }

  .filter-popup {
    position: absolute;
    width: 250px;
    z-index: 5;

    &:hover {
      cursor: auto;
    }

    &.v-card--link:focus::before {
      opacity: 0;
    }
  }
</style>
